<!-- 报价单上传 -->
<div class="main">
  <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'UploadQuotation.UploadQuotation' | translate }}</h4>
  <div class="body">
    <nz-list nzBordered>
      <nz-list-item>
        <div class="info" *ngFor="let item of quotationType">
          <div class="type">
            <span>
              <em nz-icon nzType="check-square" nzTheme="twotone"></em>
              {{ item.text }}
            </span>
          </div>
          <div class="quoted-amount">
            <!-- 报价金额 -->
            <ng-container>
              <span class="span-1" *ngIf="uploadQuotationEditStatus">*</span>
              <span class="span-2">{{ 'UploadQuotation.QuotedPrice' | translate }}:</span>
            </ng-container>
            <ng-container>
              <nz-input-number
                *ngIf="uploadQuotationEditStatus;else formDBAmount"
                [(ngModel)]="quotationInfo[item.value]['quotedAmount']"
                (ngModelChange)="ngQuotationInfoChange($event,item.value)" [nzPrecision]="2" placeholder="请填写报价金额"
                nzSize="default">
              </nz-input-number>
              <ng-template #formDBAmount>
                <span style="font-weight: 550;">
                  {{ quotationInfo[item.value]['quotedAmount'] }}
                </span>
              </ng-template>
              <span>{{ 'UploadQuotation.RMB' | translate }}</span>
            </ng-container>
          </div>
          <div class="quotation-attachment">
            <ng-container>
              <span class="span-1"
                *ngIf="uploadQuotationEditStatus">*</span>
              <span class="span-2">{{ 'UploadQuotation.QuotationFile' | translate }}:</span>
            </ng-container>
            <ng-container>
              <app-preview-upload [disabled]="quotationInfo[item.value]['fileList'].length === 1" [nzName]="nzName"
                [nzShowButton]="nzShowButtonOfUploadQuotation" [showPreviewIcon]="false"
                [nzShowUploadList]="nzShowUploadListOfUploadQuotation" (isUpload)="isUpload($event,item.value)"
                [fileList]="quotationInfo[item.value]['fileList']">
              </app-preview-upload>
            </ng-container>
          </div>
        </div>
      </nz-list-item>
    </nz-list>
  </div>
</div>